/* eslint-disable no-unused-vars */
import styled from 'styled-components';
import _ from 'lodash';
import { Rate, Carousel } from 'antd';
import moment from 'moment';
import { useRouter } from 'next/router';
import DefaultIMG from '../../assets/images/desktop_microsalts_footer_banner.png';
import UploadIMG from '../../assets/images/slide03.png';

const ReviewCard = ({ created, updated, photoUrl1, photoUrl2, photoUrl3, stars, contents, adminComment, nameHidden, applicantName, orderName, tags }) => {
  const router = useRouter();
  const pathname = _.get(router, 'pathname') === '/reviews';
  const urls = _.compact([photoUrl1, photoUrl2, photoUrl3]);
  const imageExist = !_.isEmpty(photoUrl1);
  return (
    <>
      <Containter>
        {imageExist && (
          <ImageContainer>
            <Carousel>
              {urls.map((item, i) => {
                return (
                  <>
                    <Image>
                      <img
                        style={{
                          maxWidth: '100%',
                          maxHeight: '100%',
                          height: '100%',
                          width: 'inherit'
                        }}
                        src={item.startsWith('https') ? item : `https://microsalts-media.s3.ap-northeast-2.amazonaws.com/media/images/reviews/${item}`}
                        alt=""
                      />
                    </Image>
                  </>
                );
              })}
              {urls.length === 0 && <Image dafaultImage={urls.length === 0} />}
            </Carousel>
          </ImageContainer>
        )}
        <div>
          <TagBox>{tags === 're_purchase' ? <Tag>재구매</Tag> : null}</TagBox>
          <Card>
            {nameHidden(applicantName)}님,
            <Rate style={{ color: '#2f6ecd', fontSize: '1.4rem', margin: '0 1rem' }} disabled value={stars} /> <span>{moment(created).format('YYYY.MM.DD LT')}</span>
          </Card>
          <OrderedName>{orderName ? <>{orderName}</> : <>맞춤식단</>}</OrderedName>
          <Content pathname={pathname}>{contents}</Content>
        </div>
      </Containter>
      {adminComment && (
        <Comment>
          <Administrator>맛있저염 {moment(updated).format('YYYY.MM.DD LT')}</Administrator>
          {adminComment}
        </Comment>
      )}
    </>
  );
};
const Containter = styled.div`
  ${props => props.theme.device.md} {
    padding: 1rem;
  }
`;
const ImageContainer = styled.div`
  border-radius: 10px;
  height: 250px;
  overflow: hidden;
  flex: 1;
  margin-bottom: 2rem;
`;
const Image = styled.div`
  display: flex;
  height: 250px;
  justify-content: center;
  background-image: ${props => (props.dafaultImage ? `url(${DefaultIMG})` : 'none')};
  background-position: center;
  background-repeat: no-repeat;
`;
const Card = styled.div`
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  ${props => props.theme.device.md} {
    font-size: 1.6rem;
  }
`;
const TagBox = styled.div`
  display: flex;
`;
const Tag = styled.span`
  border: 1px solid #2f6ecd;
  border-radius: 5px;
  color: #2f6ecd;
  padding: 0 1rem;
  margin-bottom: 0.5rem;
  font-size: 1.4rem;
`;
const OrderedName = styled.div`
  color: #bdbdbd;
  font-weight: bold;
  font-size: 1.2rem;
  text-align: left;
  ${props => props.theme.device.md} {
    font-size: 1.6rem;
  }
`;
const Content = styled.div`
  text-align: justify;
  overflow: hidden;
  display: -webkit-box;
  display: ${props => (props.pathname ? 'block' : '-webkit-box')};
  text-overflow: ellipsis;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
  font-size: 1.3rem;
  line-height: 1.4em;
  ${props => props.theme.device.md} {
    font-size: 1.6rem;
    line-height: 2.5rem;
  }
`;
const Comment = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  background-color: white;
  padding: 1rem;
  font-size: 1.2rem;
  border: 1px solid #bdbdbd;
  border-radius: 5px;
  ${props => props.theme.device.md} {
    font-size: 1.4rem;
    line-height: 2.2rem;
  }
`;
const Administrator = styled.span`
  color: #323232;
  font-weight: bold;
`;
export default ReviewCard;
